import { FC, useState, Fragment } from 'react';
import parse from 'html-react-parser';
import { ImageModal, Modal } from '../../../../components';
import { Typography, Box, Divider, Avatar } from '@mui/material';
import { IPunchlistItemComment } from '../../../../models';
import { formatShortFriendlyDateWithTime, getNameInitials } from '../../../../helpers';
import { TodoItemUploadsList } from './todo-item-uploads-list';

interface IPunchlistCommentList {
  punchlistComments: IPunchlistItemComment[];
}

export const PunchlistCommentList: FC<IPunchlistCommentList> = ({ punchlistComments }) => {
  const [selectedImage, setSelectedImage] = useState<string>('');
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string>('');

  return (
    <Box>
      {punchlistComments.map((punchlistComment: IPunchlistItemComment, index) => {
        return (
          <Fragment key={`${index}`}>
            <Box>
              <Box display="flex">
                <Box mr="1rem">
                  <Avatar
                    sx={{ margin: '5px', backgroundColor: theme => theme.palette.primary.dark }}
                  >
                    {getNameInitials(punchlistComment.createdBy)}
                  </Avatar>
                </Box>
                <Box width="100%">
                  <Typography sx={{ wordBreak: 'break-all' }}>
                    {punchlistComment.createdBy}
                  </Typography>
                  <Typography variant="body2" sx={{ color: theme => theme.palette.grey[600] }}>
                    {formatShortFriendlyDateWithTime(punchlistComment.createdOn)}
                  </Typography>
                  <Box mt="1rem">{parse(punchlistComment.comment)}</Box>
                  {punchlistComment.files?.length > 0 && <Divider />}
                </Box>
              </Box>
            </Box>
            {punchlistComment.files?.length > 0 && (
              <TodoItemUploadsList
                files={punchlistComment.files}
                setSelectedImage={(val: string) => setSelectedImage(val)}
                setSelectedPdf={(url: string) => {
                  fetch(url)
                    .then(response => response.blob())
                    .then(blob => {
                      let newBlob = new Blob([blob], { type: 'application/pdf' });
                      setPdfBlobUrl(URL.createObjectURL(newBlob));
                    });
                }}
              />
            )}
            {index !== punchlistComments.length - 1 ? (
              <Box mt="1rem" mb="1rem">
                <Divider />
              </Box>
            ) : (
              <></>
            )}
          </Fragment>
        );
      })}
      <ImageModal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage('')}
        source={selectedImage}
      />
      <Modal open={!!pdfBlobUrl} onClose={() => setPdfBlobUrl('')}>
        <Box sx={{ width: '100%' }}>
          <iframe width="100%" height="600" src={`${pdfBlobUrl}#toolbar=0`} title="Punchlist PDF" />
        </Box>
      </Modal>
    </Box>
  );
};
